import React, {Fragment} from "react";
import image from '../../../images/situation/nluiken/aantalLuiken.jpg'

export default function Luiken(props) {
    return <Fragment>
        <div className="addtextMore">
            Hier kunt u invullen hoeveel luiken deze specifieke situatie bevat.<br/>
            <br/>
            Voorbeeld:<br/>
            Als u twee kozijnen heeft binnen deze situatie en <br/>
            een kozijn bevat twee luiken dan voert u hier 4 in.<br/>

        </div>
        <img className="explainImage" src={image} alt=""/>
    </Fragment>;
}